/* eslint-disable react/react-in-jsx-scope */
import { useHistory } from "react-router-dom";

import { useUser } from "../../contexts/UserContext/UserContext";

import DashboardStatsBar from "./components/DashboardStatsBar";
import GettingStartedCard from "./components/GettingStartedCard";
import QuickActionsGrid from "./components/QuickActionsGrid";
import ReservationTimelineContainer from "./components/ReservationTimelineContainer";

export default function Dashboard() {
    const { state } = useUser();
    const history = useHistory();

    if (state?.user?.id && state?.isAuthenticated) {
        return (
            <div className="flex min-h-0 flex-col gap-3">
                <GettingStartedCard />
                <QuickActionsGrid />
                <DashboardStatsBar />
                <div className="flex min-h-[420px] flex-1 flex-col overflow-hidden lg:min-h-[480px]">
                    <ReservationTimelineContainer />
                </div>
            </div>
        );
    }

    history.push("/login");
    return null;
}
